import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';

import { FinleyAi } from '@finley-technologies/finley-types';

import { presignedPostUpload } from 'packages/files/ui/utils';
import { GetFinleyAiDocumentAmaUploadSignedUrlDocumentGQLType } from 'packages/finleyAi/requests/ai.gql.generated';

export type DirectUpload = ({
  file,
}: {
  file: File;
  documentName: string;
  fileExtension: FinleyAi.FinleyAiTextractSupportedFileExtension;
}) => Promise<{ s3Bucket: string; s3Path: string }>;

export const useFinleyAiDocumentAmaDirectUpload = ({
  targetOrganizationId,
}: {
  targetOrganizationId: string;
}): { directUpload: DirectUpload } => {
  const client = useApolloClient();

  const directUpload: DirectUpload = useCallback(
    async ({ file, documentName, fileExtension }) => {
      // The helper throws and captures a sentry exception if an error occurs
      const { queryResponse } = await presignedPostUpload<
        FinleyAi.FinleyAiDocumentAmaUploadRequest,
        { s3Bucket: string; s3Path: string }
      >({
        client,
        file,
        query: GetFinleyAiDocumentAmaUploadSignedUrlDocumentGQLType,
        queryVariables: {
          targetOrganizationId,
          documentName,
          fileExtension,
        },
      });

      return queryResponse;
    },
    [client, targetOrganizationId],
  );

  return {
    directUpload,
  };
};
